import React from 'react';

const Sidebar = ({ contacts, onChatClick }) => {
  return (
    <div className="sidebar">
      <h2>Messages</h2>
      <div className="search-bar">
        <input type="text" placeholder="Search contacts..." />
      </div>
      <div className="message-list">
        {contacts.map((contact) => (
          <div className="message" key={contact.id} onClick={() => onChatClick(contact)}>
            <img src={contact.profilePic} alt="profile" className="profile-pic" />
            <div className="message-details">
              <div className="name">{contact.name}</div>
              <div className="time">{contact.time}</div>
              <div className="preview">{contact.message}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
